import { render, staticRenderFns } from "./ExternalTable.vue?vue&type=template&id=0ea9cbbd&lang=pug&"
import script from "./ExternalTable.vue?vue&type=script&lang=js&"
export * from "./ExternalTable.vue?vue&type=script&lang=js&"
import style0 from "./ExternalTable.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
